<script setup lang="ts">
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useCompanyWithGroupData } from '@/composables/useCompanyWithGroupData';

    const { companiesWithGroupOptions } = useCompanyWithGroupData();

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="name"
            label="company-groups.form.labels.name"
        >
            <Input
                id="name"
                v-model="form.name"
                autocomplete="name"
                :placeholder="$t('company-groups.form.labels.name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="companyIds"
            label="company-groups.form.labels.companies"
        >
            <MultiCombobox
                v-model="form.companyIds"
                :options="companiesWithGroupOptions"
                :translate="false"
                :placeholder="$t('company-groups.form.labels.companies')"
                :loading="!companiesWithGroupOptions.length"
            />
        </InputRow>
    </div>
</template>
